module.exports = __webpack_public_path__ + "static/media/mapbox-logo-black.8838dca5.svg";